/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { EnhancedBase } from "./EnhancedBase.js";
export class EnhancedQuery extends EnhancedBase {
  constructor(common, raw) {
    super(common, raw, raw.apiName, "./ontology/queries");
    this.raw = raw;
  }
  get description() {
    return this.raw.description;
  }
  get parameters() {
    return this.raw.parameters;
  }
  get output() {
    return this.raw.output;
  }
  get typeReferences() {
    return this.raw.typeReferences;
  }
  get paramsIdentifier() {
    return `${this.shortApiName}.Parameters`;
  }
  get definitionIdentifier() {
    return this.shortApiName;
  }
  get definitionParamsIdentifier() {
    return `${this.definitionIdentifier}$Params`;
  }
}